import { Constants } from "../commons/constants";
import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";

@Injectable()
export class SecurityConfiguration{

    constructor(private oauthService: OAuthService, 
                private constants: Constants){                    
    }
    
    public validToken(){
       return this.oauthService.hasValidAccessToken();
    }

    public getClaims(){
        return window.sessionStorage;
    }

    public login() {
        this.oauthService.initImplicitFlow();
    }

    public logout(){
        this.oauthService.logoutUrl = this.constants.LogOutUrl; //"https://jci-dev.oktapreview.com/oauth2/ausp8t9fv8mXIw2gp1d6/v1/logout";
        this.oauthService.redirectUri = this.constants.redirectUri;    
        //window.location.href = this.oauthService.logoutUrl;   
        this.oauthService.logOut();
        // sessionStorage.clear();
        // localStorage.clear();    
    }

    // public inializeOAuthConfigs() {
    //     this.oauthService.loginUrl = this.constants.AUTHORIZATION_URL;
    //     this.oauthService.redirectUri = this.constants.LOCAL_URL;
    //     this.oauthService.clientId = this.constants.CLIENT_ID;
    //     this.oauthService.issuer = this.constants.IMS_URL;
    //     this.oauthService.responseType = this.constants.RESPONSE_TYPE;
    //     this.oauthService.logoutUrl = this.constants.LOCAL_URL;
    //     this.oauthService.setStorage(window.sessionStorage);
    //     this.oauthService.scope = this.constants.CLIENT_SCOPES;
    //     this.oauthService.tryLogin({});
    // }

    public inializeOAuthConfigsNew() {        
        this.oauthService.redirectUri = this.constants.redirectUri;
        this.oauthService.clientId = this.constants.clientId;
        this.oauthService.issuer = this.constants.issuer;
        this.oauthService.responseType = this.constants.responseType;
        this.oauthService.logoutUrl = this.constants.redirectUri;
        this.oauthService.setStorage(window.sessionStorage);
        this.oauthService.scope = this.constants.scope;      
        this.oauthService.loadDiscoveryDocumentAndLogin();
        //this.oauthService.initImplicitFlow();
    }
}



// WEBPACK FOOTER //
// ./src/security/security.configuration.ts